<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'game_list'}" class="float-left mr-1 main-link">{{$t('game.game')}}</router-link> / {{$t('game.detail')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <!-- Default conditions -->
          <b-card header-tag="header" footer-tag="footer" class="heade mb-4">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('game.default_conditions') }}</strong>
            </div>
            <b-collapse :visible.sync="toggleConditions" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('game.default_rule_apply')}}</legend>
                    <div class="col-sm-5">
                      <c-switch type="icon" variant="success" class="mb-0" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="default_conditions.is_default_rule" :value="true" :uncheckedValue="false"/>
                    </div>
                    <div class="col-sm-12">
                      <p class="font-italic mb-0 mt-2">{{$t('game.msg_default_rule_apply')}}</p>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('game.default_token_per_order')}}</legend>
                    <div class="col-sm-5">
                      <b-form-input v-model="default_conditions.token_per_order" type="number" :min="1" :disabled="default_conditions.is_default_rule"/>
                    </div>
                  </div>

                </b-col>
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('game.default_min_spend')}}</legend>
                    <div class="col-sm-5">
                      <b-form-input v-model="default_conditions.min_spend" type="number" :min="1" :disabled="default_conditions.is_default_rule"/>
                    </div>
                  </div>
                  <div class="font-italic mb-4">{{ $t('game.default_rule_note') }}</div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Default conditions -->

          <!-- Special Rules -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header" class="d-flex align-items-center">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('game.special_rules') }}</strong>
              <div class="ml-auto">
                <button type="button" class="btn btn-success" style="margin-top: 0" @click="openModalGameRule(null, null)"><i class="fa fa-plus"></i>&nbsp; {{$t('game.new_rule')}}</button>
              </div>
            </div>
            <b-collapse :visible.sync="toggleGameRules" id="time_settings_content">
              <b-form class="row">
                <b-col cols="12">
                  <!-- calendar show -->
                  <full-calendar :data-events="dataEvents" @openUpdateEvent="(item, date) => openModalGameRule(item, date)" @updateGameRuleEventWithSpecialDate="updateGameRuleEventWithSpecialDate" @deleteGameRuleEvent="deleteGameRuleEvent"></full-calendar>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Special Rules -->
           
          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'game_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button variant="success" v-on:click="saveGameRule()">{{$t('common.save')}}</b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
    <modal-game-rule @updateGameRuleEvent="updateGameRuleEvent" @deleteGameRuleEvent="deleteGameRuleEvent"></modal-game-rule>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import FullCalendar from '../../../components/Partials/FullCalendar.vue'
import ModalGameRule from './ModalGameRule.vue'
import cSwitch from '@/components/Switch'

export default {
  components: {
    FullCalendar,
    ModalGameRule,
    cSwitch
  },
  data: function () {
    return {
      dataEvents: [],
      dataGameRule: {
        default_parameters: {},
        timezones: [this.$const.CLIENT_TIMEZONE[this.$store.getters.config.base.id] || this.$moment.tz.guess()],
        special_rules: []
      },
      toggleConditions: true,
      toggleGameRules: true,
      default_conditions: {
        is_default_rule: false,
        token_per_order: 1,
        min_spend: 10
      }
    }
  },
  mixins: [
    validationMixin
  ],
  created: function () {
  },
  mounted: function(){
    this.getDataSpecialRuleList()
  },
  methods: {
    getDataSpecialRuleList () {
      const vm = this
      vm.dataEvents = []
      this.axios.coupon.getGameRuleList(response => {
        vm.dataGameRule = (response.data && response.data.data) || {}
        vm.default_conditions = vm.dataGameRule && vm.dataGameRule.default_parameters
        vm.refreshGameRule()
      });
    },
    openModalGameRule(item, date) {
      this.$root.$emit('showModalGameRule', item, date, this.default_conditions, this.dataEvents)
    },
    refreshGameRule () {
      const dataEvents = []
      if (this.dataGameRule.special_rules && this.dataGameRule.special_rules.length > 0) {
        this.dataGameRule.special_rules.forEach(element => {
          dataEvents.push(element.eventData)
        });
      }
      this.dataEvents = dataEvents
    },
    updateGameRuleEventWithSpecialDate(item) {
      const index = this.dataGameRule.special_rules.findIndex(event => Number(event.id) == Number(item.id))
      this.dataGameRule.special_rules[index].eventData = item
      this.refreshGameRule()
    },
    updateGameRuleEvent(item, days_of_week_values) {
      const data = {
        id: item.id || null,
        eventData: item,
        name: item.name,
        min_spend: item.min_spend,
        order_type: item.order_type,
        sales_channel: item.sales_channel,
        token_per_order: item.token_per_order,
        special_dates: [],
        opening_times: days_of_week_values
      }
      if (!item.id) {
        const id = new Date().getTime()
        data.id = id
        data.eventData.id = id
        this.dataGameRule.special_rules.push(data)
      } else {
        const index = this.dataGameRule.special_rules.findIndex(event => Number(event.id) == Number(item.id))
        this.dataGameRule.special_rules[index] = data
      }
      this.refreshGameRule()
    },
    deleteGameRuleEvent(item) {
      let vm = this
      const index = this.dataGameRule.special_rules.findIndex(event => Number(event.id) == Number(item.id))
      if (index === -1) {
        this.$toastr.error(this.$t('message.error'), this.$t('message.success'), {})
        return
      } else {
        let options = {
          html: true,
          okText: this.$t('common.ok'),
          cancelText: this.$t('common.cancel')
        }
        this.$dialog.confirm(this.$t('delete_game_rule_confirm'), options)
          .then(function (dialog) {
            vm.dataGameRule.special_rules.splice(index, 1)
            vm.refreshGameRule()
          })
          .catch(function () {
          }
        )
      }
    },
    saveGameRule () {
      const vm = this
      if (!this.default_conditions.token_per_order || !this.default_conditions.min_spend) {
        this.$toastr.error(this.$t('validate_game'), this.$t('message.error'), {})
        return
      } else if (this.default_conditions.token_per_order <= 0) {
        this.$toastr.error(this.$t('validate_token_per_order'), this.$t('message.error'), {})
        return
      }
      const options = {
        html: true,
        okText: vm.$t('common.save'),
        cancelText: vm.$t('common.cancel')
      }
      const user = this.$auth.user()
      for (let i = 0; i < this.dataGameRule.special_rules.length; i++) {
        const element = this.dataGameRule.special_rules[i];
        element.seq = i + 1
        element.special_dates = []
        if (element.eventData && element.eventData.special_dates && element.eventData.special_dates.length > 0) {
          element.eventData.special_dates.forEach(date => {
            element.special_dates.push({
              from: vm.getValueFromAttr(element.eventData, 'startTime'),
              to: vm.getValueFromAttr(element.eventData, 'endTime'),
              date: date,
              active: 1
            })
          });
        }
      }
      const emailUser = (user && user.user_info && user.user_info.user) ? user.user_info.user.email : ''
      vm.$dialog.confirm(vm.$t('message.delete_confirm'), options).then(function (dialog) {
        vm.axios.coupon.editGameRuleList(emailUser, vm.dataGameRule, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        }, function (error) {
          console.log(error)
        })
      }).catch(function () {
      })
    }
  }
}
</script>

<style>
  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

</style>

<style scoped>
  .list-rule {
    width: 100%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }


  .card{
    margin-bottom: 0;
  }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/game/GamingRule.vue